
export const pushTcClicEvent = (clicName: string): void => {
  const tcVars =  { actionClic: 'Clic_redirection', categorieClic: 'Depannage_en_ligne', nomClic: clicName };
  window.tc_vars = tcVars;
  tc_events_2(window, 'clic', tcVars);
};
